import { jsxs as Q, jsx as o } from "react/jsx-runtime";
import { c as k } from "./index-65016bfa.mjs";
import { useCallback as S } from "react";
import "@fcamna/shared-component-foundations";
import { u as T } from "./useQuantum-50e8fd44.mjs";
import { b as B } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as l } from "./icon.js";
import h, { css as $ } from "styled-components";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
const F = h.a`
  &.Link {
    ${({
  theme: {
    components: { link: r }
  }
}) => $(r.Link)}
  }
`, u = h.span`
  &.Link__icon {
    ${({
  theme: {
    components: { link: r }
  }
}) => $(r.IconWrapper)}
  }
`, K = ({
  size: r = "small",
  variant: b = "default",
  isDisclosureLink: p = !1,
  disclosureNumber: L,
  isCurrentPage: f = !1,
  disabled: n = !1,
  leadingIcon: t,
  trailingIcon: a,
  to: s,
  target: e,
  rel: d,
  as: x,
  renderAs: P = x,
  accessibilityOption: E,
  className: N,
  onClick: i,
  onKeyDown: m,
  children: W,
  ...j
}) => {
  const A = T({ label: "Link" }), q = B(s ? "link" : "button", { ...E, ariaDisabled: n }), _ = (s == null ? void 0 : s.startsWith("http")) || (s == null ? void 0 : s.startsWith("#")), v = e || (_ ? "_blank" : "_self"), y = { as: P, to: s }, H = { href: s, rel: d, target: v }, M = S(
    (c) => {
      (c.code === "Enter" || !s && !e && c.code === "Space") && (i == null || i(c), m == null || m(c));
    },
    [i, m, e, s]
  );
  return /* @__PURE__ */ Q(
    F,
    {
      ...j,
      as: f ? "span" : "a",
      disabled: n,
      tabIndex: n ? -1 : void 0,
      ...!_ && !n && y,
      ...!f && !n && H,
      ...q,
      role: s ? "link" : "button",
      onClick: n ? void 0 : i,
      onKeyDown: M,
      "data-disclosure-number": p && L ? L : void 0,
      className: k([
        "Link",
        `Link--${b}`,
        `Link--${r}`,
        N,
        {
          "Link--disabled": n,
          "Link--disclosure": p,
          "disclosure-superscript-link": p
        }
      ]),
      ...A,
      children: [
        t && /* @__PURE__ */ o(u, { className: k(["Link__icon", "Link__icon--left", `Link__icon--${r}`]), children: typeof t == "string" ? /* @__PURE__ */ o(l, { name: t }) : t }),
        W,
        a && /* @__PURE__ */ o(u, { className: k(["Link__icon", "Link__icon--right", `Link__icon--${r}`]), children: typeof a == "string" ? /* @__PURE__ */ o(l, { name: a }) : a })
      ]
    }
  );
};
export {
  K as Link
};
